import { render, staticRenderFns } from "./MultipleImageChoice.vue?vue&type=template&id=59e65f1b&scoped=true"
import script from "./MultipleImageChoice.vue?vue&type=script&lang=js"
export * from "./MultipleImageChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e65f1b",
  null
  
)

export default component.exports